import { apiClient } from '../../../client'

export type AttendanceSheetRow = {
  display_name: string
  user_name: string
  report_to_name: string
  city_name: string
  region_name: string
  slots: Record<string, string>
}

export type AttendanceSheetFilters = {
  region_ids?: string
  city_ids?: string
  user_ids?: string
  report_to_ids?: string
}

class AttendanceSheetRepository {
  async getAttendance(
    year: number,
    month: number,
    filters?: AttendanceSheetFilters,
  ): Promise<{ data: AttendanceSheetRow[] }> {
    const params = new URLSearchParams({ year: String(year), month: String(month) })
    if (filters?.region_ids) params.set('region_ids', filters.region_ids)
    if (filters?.city_ids) params.set('city_ids', filters.city_ids)
    if (filters?.user_ids) params.set('user_ids', filters.user_ids)
    if (filters?.report_to_ids) params.set('report_to_ids', filters.report_to_ids)
    return apiClient.get<{ data: AttendanceSheetRow[] }>(`/attendance-sheet?${params.toString()}`)
  }

  async exportAttendance(params: {
    year: number
    month: number
    filters?: AttendanceSheetFilters
  }): Promise<Blob> {
    const query = new URLSearchParams({
      year: String(params.year),
      month: String(params.month),
    })
    if (params.filters?.region_ids) query.set('region_ids', params.filters.region_ids)
    if (params.filters?.city_ids) query.set('city_ids', params.filters.city_ids)
    if (params.filters?.user_ids) query.set('user_ids', params.filters.user_ids)
    if (params.filters?.report_to_ids) query.set('report_to_ids', params.filters.report_to_ids)

    return apiClient.getBlob(`/attendance-sheet/export?${query.toString()}`)
  }
}

export const attendanceSheetRepository = new AttendanceSheetRepository()
